import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import FortisButton from '../../components/Basic/FortisButton';
import CheckBox from '../../components/Basic/CheckBox';
import util from '../../lib/util';


class VerifyEmail extends React.Component {
  constructor(props) {
    super(props);
    props.initAPI();
    this.state = { isEmailVerifyCalled: false, isSubmitClicked: false };
  }


  componentWillReceiveProps(p) {
    if (p.verifyEmailSuccess && p.verifyEmailSuccess.success) {
      window.location.href = 'http://www.fortisbc.com';
      p.resetVerifyEmailSuccess();
    }
  }
  onSubmitClick = () => {
    const p = this.props;
    let validators = [
      ['confirmVerifyEmail', p => p.confirmVerifyEmail == "1"]
    ];
    if (util.validate(validators, p.form, p.formError)) {
      let model = {
        Email: p.email,
        ProjectNo: p.projectNo,
        IsVerified: true
      };
      p.verifyEmail(model);
    }
  }
  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <h3 className="text-primary">Thank you for verifying your email address</h3>
            <h4>Please confirm you would like to receive notifications from FortisBC.</h4>
            <h5>We require your consent to receive electronic communications from us. You can unsubscribe at any time by clicking the unsubscribe link included in all email communications.</h5>
            <label>Confirmation</label>
            <CheckBox name="confirmVerifyEmail" title="I agree to receive all future email notifications from FortisBC related to this project." required />

          </div>
        </div>
        <div className="row">
          <div className="col-md-3">
            <div className="row text-center">
              <div className="col-lg-12" style={{ "display": "inline-block" }}>
                <FortisButton text="Submit" onClick={this.onSubmitClick} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

VerifyEmail.propTypes = {
  form: PropTypes.object,
  projectNo: PropTypes.string,
  email: PropTypes.string,
  verifyEmailSuccess: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    form: state.form,
    confirmVerifyEmail: state.form.confirmVerifyEmail,
    projectNo: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["projectNo"],
    email: state.routing.locationBeforeTransitions && state.routing.locationBeforeTransitions.query["email"],
    verifyEmailSuccess: state.gas.verifyEmailSuccess
  };
}
function mapDispatchToProps(dispatch) {
  return {
    initAPI :() => {
        //  dispatch({ type: 'INITIALIZE_STORE' });
          dispatch({ type: 'INITIALIZE_API' });
        },
    formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
    verifyEmail: (model) => dispatch({ type: 'VERIFY_EMAIL', model }),
    resetVerifyEmailSuccess: () => dispatch({ type: 'VERIFY_EMAIL_SUCCESS', verifyEmailSuccess: null })
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(VerifyEmail);

